import { createComponent } from '@lib/util/templateHelpers';
import shared from '@lib/components';
const { App, Layout } = shared;

import AppHeader from '@/components/AppHeader';
import AppFooter from '@/components/AppFooter';

import styles from './index.module.scss';

export default createComponent('FillScreenLayout', { styles }, function FillScreenLayout ({ className }, props) {
  return (
    <Layout className={className}>
      <App.Header>
        <AppHeader />
      </App.Header>

      <App.Main>
        {props.children}
      </App.Main>

      <App.Footer>
        <AppFooter hasBannerAd={props.hasBannerAd} />
      </App.Footer>
    </Layout>
  )
});
